import { render, staticRenderFns } from "./semantics-distribution-chart.component.vue?vue&type=template&id=79f503d6&scoped=true"
import script from "./semantics-distribution-chart.component.vue?vue&type=script&lang=ts"
export * from "./semantics-distribution-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./semantics-distribution-chart.component.vue?vue&type=style&index=0&id=79f503d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f503d6",
  null
  
)

export default component.exports